/* ==========================================================================
   MIRRORS OF FATE — Theme JavaScript
   Author: Absolute AV · v1.0.0
   Zero dependencies. Every feature degrades gracefully without JavaScript.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;

  /* Mark the document as JS-capable (enables scroll-reveal styling even when
     this script runs inside a host theme that lacks the no-js/js convention). */
  doc.documentElement.classList.add('js');

  /* ------------------------------------------------------------------
     1. Sticky header state
  ------------------------------------------------------------------ */
  var header = doc.querySelector('[data-mof-header]');
  if (header) {
    var setStuck = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    setStuck();
    window.addEventListener('scroll', setStuck, { passive: true });
  }

  /* ------------------------------------------------------------------
     2. Mobile navigation drawer
  ------------------------------------------------------------------ */
  var drawer = doc.getElementById('MofDrawer');
  if (drawer) {
    var openBtns = doc.querySelectorAll('[data-drawer-open]');
    var closeBtns = drawer.querySelectorAll('[data-drawer-close]');
    var lastFocused = null;

    var openDrawer = function () {
      lastFocused = doc.activeElement;
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      doc.body.classList.add('mof-lock');
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var firstLink = drawer.querySelector('a, button');
      if (firstLink) firstLink.focus();
    };

    var closeDrawer = function () {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      doc.body.classList.remove('mof-lock');
      openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    };

    openBtns.forEach(function (b) { b.addEventListener('click', openDrawer); });
    closeBtns.forEach(function (b) { b.addEventListener('click', closeDrawer); });

    drawer.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (link) closeDrawer();
    });

    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* ------------------------------------------------------------------
     3. Scroll-reveal animations (respects prefers-reduced-motion)
  ------------------------------------------------------------------ */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealEls = doc.querySelectorAll('.mof-reveal');
  if (revealEls.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-revealed'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealEls.forEach(function (el) { io.observe(el); });
    }
  }

  /* ------------------------------------------------------------------
     4. Product form: variant select → price, availability, URL
  ------------------------------------------------------------------ */
  doc.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var scope = select.closest('[data-product-form]') || doc;
    var priceEl = scope.querySelector('[data-price-target]');
    var compareEl = scope.querySelector('[data-compare-target]');
    var buttonEl = scope.querySelector('[data-add-button]');
    var stockEl = scope.querySelector('[data-stock]');

    var sync = function () {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      var available = opt.getAttribute('data-available') === 'true';

      if (priceEl && opt.getAttribute('data-price')) priceEl.textContent = opt.getAttribute('data-price');
      if (compareEl) {
        var cmp = opt.getAttribute('data-compare');
        compareEl.textContent = cmp || '';
        compareEl.hidden = !cmp;
      }
      if (buttonEl) {
        buttonEl.disabled = !available;
        var soldOutText = buttonEl.getAttribute('data-text-soldout') || 'Sold Out';
        var defaultText = buttonEl.getAttribute('data-text-default') || 'Add to Cart';
        var label = buttonEl.querySelector('[data-add-label]') || buttonEl;
        label.textContent = available ? defaultText : soldOutText;
      }
      if (stockEl) {
        stockEl.classList.toggle('is-out', !available);
        stockEl.textContent = available
          ? (stockEl.getAttribute('data-text-in') || 'Available')
          : (stockEl.getAttribute('data-text-out') || 'Sold out');
      }
      if (opt.value && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', opt.value);
        window.history.replaceState({}, '', url.toString());
      }
    };

    select.addEventListener('change', sync);
    sync();
  });

  /* ------------------------------------------------------------------
     5. Quantity steppers
  ------------------------------------------------------------------ */
  doc.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;

    var wrap = (minus || plus).closest('.mof-qty');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (!input) return;

    var value = parseInt(input.value, 10);
    if (isNaN(value)) value = 1;
    var min = parseInt(input.getAttribute('min'), 10) || 0;
    value = plus ? value + 1 : Math.max(min, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------
     6. Submit-state feedback on forms
  ------------------------------------------------------------------ */
  doc.querySelectorAll('form[data-mof-loading], form.mof-js-loading').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('[type="submit"]');
      if (btn && !btn.disabled) {
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
      }
    });
  });
})();
